import React, { Component } from 'react';
import { DialogActions, Button, TextField, DialogContent, DialogTitle, Dialog, MenuItem } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import companyService from '../../api/companiesService';
import { cleanCompany } from '../../redux/actions/companyActions';
import { distinct } from '../../shared/helpers/distinctArray';
import { getSelectOptions } from '../../shared/helpers/selectHelper';


class CompanyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            name: '',
            responsibleName: '',
            email: '',
            city: '',
            stateCode: ''
        };

        this.changeName = this.changeName.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.changeResponsibleName = this.changeResponsibleName.bind(this);
        this.changeCity = this.changeCity.bind(this);
        this.changeStateCode = this.changeStateCode.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.addCompany = this.addCompany.bind(this);
        this.updateCompany = this.updateCompany.bind(this);
        this.setCompanyDetails = this.setCompanyDetails.bind(this);
    }

    setCompanyDetails() {
        if (this.props.selectedCompany) {
            const { id, name, responsibleName, email, city, stateCode } = this.props.selectedCompany;
            this.setState({
                id,
                name,
                responsibleName,
                email,
                city,
                stateCode
            });
        } else {
            this.setState({
                id: null,
                name: '',
                responsibleName: '',
                email: '',
                city: '',
                stateCode: ''
            });
        }
    }

    closeModal() {
        this.props.cleanCompany();
        this.props.hideForm();
    }

    changeName(evt) {
        this.setState({
            name: evt.target.value
        });
    }

    changeEmail(evt) {
        this.setState({
            email: evt.target.value
        });
    }

    changeResponsibleName(evt) {
        this.setState({
            responsibleName: evt.target.value
        });
    }

    changeCity(evt) {
        this.setState({
            city: evt.target.value
        });
    }

    changeStateCode(evt) {
        this.setState({
            stateCode: evt.target.value
        });
    }

    addCompany() {
        const { name, responsibleName, email, city, stateCode } = this.state;
        companyService.addCompany(name, responsibleName, email, city, stateCode)
            .then(() => {
                this.closeModal();
            });
    }

    updateCompany() {
        const { id, name, responsibleName, email, city, stateCode } = this.state;
        companyService.updateCompany(id, name, responsibleName, email, city, stateCode)
            .then(() => {
                this.closeModal();
            });
    }    

    render() {
        const { showModal, cities, states } = this.props;
        const { id, name, responsibleName, email, city, stateCode } = this.state;
        const isEditing = Boolean(id);

        const citiesFiltered = this.state.stateCode !== '' ?
            distinct(cities.filter((city) => city.stateCode === this.state.stateCode), "value")            
            :
            [{ value: '', display: 'Select a State.' }];

        return (
            <Dialog onRendered={() => {
                this.setCompanyDetails();
            }} open={showModal} onClose={this.closeModal} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{isEditing ? `Editing ${name}'s details` : "Add a new Company"}</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="normal"
                        id="name"
                        variant="outlined"
                        label="Name"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeName}
                        value={name}
                        fullWidth
                    />
                    <TextField
                        margin="normal"
                        id="responsible-name"
                        variant="outlined"
                        label="Responsible Name"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeResponsibleName}
                        value={responsibleName}
                        fullWidth
                    />
                    <TextField
                        margin="normal"
                        id="email"
                        variant="outlined"
                        label="E-mail address"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeEmail}
                        value={email}
                        fullWidth
                    />
                    <TextField
                        select
                        margin="normal"
                        id="name"
                        variant="outlined"
                        label="State"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeStateCode}
                        value={stateCode}
                        fullWidth
                    >
                        {getSelectOptions(states)}
                    </TextField>

                    <TextField
                        select
                        margin="normal"
                        id="name"
                        variant="outlined"
                        label="City"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeCity}
                        value={city}
                        fullWidth
                    >
                        {getSelectOptions(citiesFiltered)}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeModal} color="primary">Back</Button>
                    <Button onClick={isEditing ? this.updateCompany : this.addCompany} color="primary">
                        {isEditing ? "Save" : "Add"}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = ({ companyState, locationState }) => ({
    selectedCompany: companyState.selectedCompany,
    cities: locationState.localizations.map((city) => ({ value: city.cityName, display: city.cityName, stateCode: city.state.stateCode })),
    states: distinct(locationState.localizations.map((city) => ({ value: city.state.stateCode, display: city.state.state })), "value")
        .sort((a, b) => {
            if (a.display < b.display)
                return -1;
            if (a.display > b.display)
                return 1;
            return 0;
        })
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ cleanCompany }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyForm);